/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import { Button } from 'react-bootstrap';
import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  margin-left: 3%;
  @media (max-width: 480px) {
    justify-content: center;
    display: block;
  }
`;
export const btn = styled(Button)`
  color: white;
  &:hover {
    // background-color: #1f2937;
    // color: white;
    box-shadow: 1px 1px 10px gray;
  }
`;
